export class MItem {
  indexNo: number;
  barcode: string;
  details: string;
  price: number;
}



// WEBPACK FOOTER //
// ./src/app/view/service/m-item/model/m-item.ts